module.exports = __webpack_public_path__ + "static/media/money-pounds-two.dc890c72.svg";